// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qmQG","footer":"styles_footer__hleEY","passCodeTooltip":"styles_passCodeTooltip__qBWD2"};